<template>
    <div>
        <div class="topimage">
            <el-image style="width:100%"
                :src="require('@/assets/product/banner' + (this.$i18n.locale == 'zh' ? '' : '_' + this.$i18n.locale) + '.jpg')"></el-image>
        </div>

        <!-- <div class="duibi-wrap">
            <div style="position: absolute;right: 5%;top: 20px;" @click="nav('contrast')">
                <div class="duibi-btn">
                    <el-image style="width: 100%;max-height: 225px;"
                        :src="require('@/assets/product/duibi_' + $i18n.locale + '.png')">
                    </el-image>
                    <div class="duibi-badge" v-if="duibiProduct.length > 0">
                        {{ duibiProduct.length }}
                    </div>
                </div>
            </div>
        </div> -->

        <div class="appmain">
            <div class="product-wrap">
                <div class="product-tabs-wrap">
                    <div class="product-tabs">
                        <div class="product-tabs-item" :class="{ 'product-tabs-item_active': class_id == item.cat_id }"
                            v-for="(item, index) in classList" :key="index" @click='tabclick(item)'>{{ item.cat_name }}
                        </div>
                    </div>
                </div>
                <div class="product-content">
                    <el-radio-group class="xilie" v-model="checkboxGroup4" size="mini" @change="checkboxchang">
                        <el-radio-button v-for="(item, index) in xilielist" :label="item.cat_id" :key="index">{{
                            item.cat_name }}</el-radio-button>
                    </el-radio-group>

                    <div class="xiliemiaoshu-wrap" v-if="xiliemiaoshu != null && xiliemiaoshu != ''">
                        <div class="xilietitle">
                            {{ catName }}
                        </div>
                        <div class="xiliemiaoshu">
                            {{ xiliemiaoshu }}
                        </div>
                    </div>

                    <div class="chanpinlist">
                        <div class="chanpin-item" v-for="(item, index) in productlists" :key="index"
                            @click="nav(`product/${item.product_id}/${encodeURIComponent(item.productModel)}`)">

                            <!-- <div v-if="duibiProduct.includes(item.product_id)" class="duibi-del-btn"
                                @click.stop="delDuibi(item)">
                                <i class="el-icon-remove-outline" :title="$t('productinfo.yiduibi')"></i>
                            </div>
                            <div v-else class="duibi-add-btn" @click.stop="addDuibi(item)">
                                <i class="el-icon-circle-plus-outline" :title="$t('productinfo.duibi')"></i>
                            </div> -->

                            <el-image class="chanpinimage" :src="item.images"></el-image>
                            <div class="chanpintitle">
                                {{ item.product_model == null || item.product_model == '' ?
                                    item.product_name
                                    : item.product_model + ' ' + item.product_name }}
                            </div>
                            <div class="chanpinfubiao">
                                {{ item.product_feature }}
                            </div>
                        </div>
                    </div>
                    <el-pagination v-if="total > 0"
                        style="margin-top:20px;text-align:center;width: 100%;overflow: hidden;"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="productParams.page" :page-sizes="[1, 24, 48]" :page-size="productParams.limit"
                        layout="total, prev, pager, next" :pager-count="3" :total="total">
                    </el-pagination>
                </div>

            </div>

            <div class="fangan-wrap">

                <el-radio-group class="fangan-radio" v-model="radio">
                    <el-radio-button :label="0" v-if="projects.length > 0" size="medium">{{ $t('layout.solution')
                        }}</el-radio-button>
                    <el-radio-button :label="1" v-if="schemes.length > 0">{{ $t('layout.application')
                        }}</el-radio-button>
                    <el-radio-button :label="2" v-if="news.length > 0">{{ $t('layout.news') }}</el-radio-button>
                </el-radio-group>

                <!-- <div class="datitle" v-if="schemes.length>0 && radio == 0">{{$t('layout.solution')}}</div> -->
                <div class="fangan-list" v-if="schemes.length > 0 && radio == 0">
                    <div class="fangan-list-item" v-for="(item, index) in schemes" :key="index"
                        @click="nav2('/scheme/' + item.scheme_id)">
                        <div class="jjimage-wrap">
                            <el-image class="jjimage" :src="item.scheme_image" fit="scale-down"></el-image>
                        </div>
                        <div class="jjtitle">{{ item.scheme_title }}</div>
                    </div>
                </div>
                <!-- <div class="datitle" v-if="projects.length>0 && radio == 1">{{$t('layout.application')}}</div> -->
                <div class="anli" v-if="projects.length > 0 && radio == 1">
                    <div class="anli-item" v-for="(item, index) in projects" :key="index"
                        @click="nav2('/projectinfo/' + item.project_id)">
                        <div class="yytitl">{{ item.project_title }}</div>
                        <div class="yytitles">{{ item.project_desc_text }}</div>
                    </div>
                </div>
                <div class="anli" v-if="news.length > 0 && radio == 2">
                    <div class="anli-item" v-for="(item, index) in news" :key="index"
                        @click="nav2('/news_info/' + item.news_id)">
                        <div class="yytitl">{{ item.news_title }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import { productsClass, productsList, productRelatedList } from "@/api/api"
    export default {
        data() {
            return {
                checkboxGroup4: 0,
                classList: [],
                xilielist: [],
                productlists: [],
                productRelateds: {},
                productParams: {
                    cat_id: '1',
                    page: 1,
                    limit: 24
                },
                total: 0,
                class_id: '',
                title: '',
                seo: {
                    keyword: '',
                    description: ''
                },
                duibiProduct: [],
                radio: 0,
                news: [],
                schemes: [],
                projects: [],
                xiliemiaoshu: null,
                catName: null,
            }
        },
        created() {
            let duibiProduct = JSON.parse(sessionStorage.getItem("duibiProduct"))
            if (duibiProduct == null) {
                duibiProduct = []
            }
            this.duibiProduct = duibiProduct
            this.title = this.$t('layout.productcenter') + '-' + this.$t('seo.indextitle')
            let class_id = this.$route.query.class_id
            if (class_id != undefined) {
                this.class_id = class_id + ''
            }
            let id = this.$route.query.id
            if (id != undefined) {
                this.checkboxGroup4 = id
                this.productParams.cat_id = id
            }
            let page = this.$route.query.page
            if (page != undefined) {
                this.productParams.page = page - 0
            }
            this.getListClass()
        },
        // 在销毁前，将body的style属性删除
        deactivated() {
            sessionStorage.removeItem("duibiProduct")
            this.duibiProduct = []
        },
        mounted() {
        },
        metaInfo() {
            return {
                title: this.title,
                meta: [
                    {
                        name: 'keyWords',
                        content: this.seo.keyword
                    },
                    {
                        name: 'description',
                        content: this.seo.description
                    }
                ]
            }
        },
        methods: {
            async getListClass() {
                const { data: res } = await productsClass()
                this.classList = res
                let arr = [{ cat_id: this.class_id, cat_name: this.$t('all') }]
                if (this.class_id != 0) {
                    if (this.$route.query.id != 0 && this.$route.query.id != undefined) {
                        this.productParams.cat_id = this.$route.query.id
                    } else {
                        this.productParams.cat_id = this.class_id
                    }
                    res.forEach((item, index) => {
                        if (item.cat_id == this.class_id) {
                            arr.push(...this.classList[index].children)
                            if (this.$route.query.id != 0 && this.$route.query.id != undefined) {
                                item.children.forEach((item2, index) => {
                                    if (item2.cat_id == this.$route.query.id) {
                                        this.xiliemiaoshu = item2.xiliemiaoshu
                                        this.catName = item2.cat_name
                                    }
                                })
                            } else {
                                this.xiliemiaoshu = item.xiliemiaoshu
                                this.catName = item.cat_name
                            }
                        }
                    })
                } else {
                    this.productParams.cat_id = this.classList[0].cat_id
                    this.class_id = this.classList[0].cat_id + ''
                    arr.push(...this.classList[0].children)
                    this.xiliemiaoshu = this.classList[0].xiliemiaoshu
                    this.catName = this.classList[0].cat_name
                }
                this.xilielist = arr
                this.getProductsList()
                this.getProductRelatedList()
            },
            async getProductsList() {
                const { data: res } = await productsList(this.productParams)
                res.list.forEach((item, index) => {
                    let imageIndex = 0
                    while (item.get_image_list[imageIndex] && item.get_image_list[imageIndex].product_img.endsWith('.gif')) {
                        imageIndex++
                    }

                    if (item.get_image_list[imageIndex]) {
                        item.images = process.env.VUE_APP_BASE_API + item.get_image_list[imageIndex].product_img
                    } else {
                        item.images = process.env.VUE_APP_BASE_API + item.get_image_list[0].product_img
                    }
                })
                this.total = res.total
                this.productlists = res.list
                this.seo = res.seo
                history.pushState(null, null, "/productinfo?class_id=" + this.class_id + '&page=' + this.productParams.page + '&id=' + this.checkboxGroup4)
            },
            async getProductRelatedList() {
                const { data: res } = await productRelatedList(this.productParams)
                res.projects.forEach((item) => {
                    item.project_img = process.env.VUE_APP_BASE_API + item.project_img
                })
                res.schemes.forEach((item) => {
                    item.scheme_image = process.env.VUE_APP_BASE_API + item.scheme_image
                })
                this.projects = res.projects
                this.news = res.news
                this.schemes = res.schemes
            },
            checkboxchang(data) {
                this.xiliemiaoshu = null
                this.catName = null
                if (data != 1) {
                    this.xilielist.forEach((item, index) => {
                        if (item.cat_id == data) {
                            this.xiliemiaoshu = item.xiliemiaoshu
                            this.catName = item.cat_name
                        }
                    })
                } else {
                    this.classList.forEach((item, index) => {
                        if (item.cat_id == this.class_id) {
                            this.xiliemiaoshu = item.xiliemiaoshu
                            this.catName = item.cat_name
                        }
                    })
                }
                this.checkboxGroup4 = data
                this.productParams.page = 1
                if (data == 0) {
                    this.productParams.cat_id = this.class_id
                    this.getProductsList()
                    this.getProductRelatedList()
                } else {
                    this.productParams.cat_id = data
                    this.getProductsList()
                    this.getProductRelatedList()
                }
            },
            tabclick(data) {
                this.class_id = data.cat_id
                this.xiliemiaoshu = null
                this.catName = null
                this.xiliemiaoshu = data.xiliemiaoshu
                this.catName = data.cat_name
                this.checkboxGroup4 = this.class_id
                let arr = [{ cat_id: this.class_id, cat_name: this.$t('all') }]
                arr.push(...data.children)
                this.xilielist = arr
                this.productParams.cat_id = data.cat_id
                this.productParams.page = 1
                this.getProductsList()
                sessionStorage.removeItem("duibiProduct")
                this.duibiProduct = []
            },
            nav(item) {
                if (item == 'contrast') {
                    if (this.duibiProduct.length > 0) {
                        localStorage.setItem('duibiProduct', JSON.stringify(this.duibiProduct))
                    } else {
                        localStorage.setItem('duibiProduct', JSON.stringify([]))
                    }
                }
                window.open('/' + item)
            },
            nav2(path) {
                window.open(path)
            },
            handleSizeChange(value) {
                this.productParams.limit = value
                this.getProductsList()
            },
            handleCurrentChange(value) {
                this.productParams.page = value
                this.getProductsList()
            },
            addDuibi(row) {
                if (!this.duibiProduct) {
                    this.duibiProduct = [row.product_id]
                } else {
                    this.duibiProduct.push(row.product_id)
                }
                sessionStorage.setItem("duibiProduct", JSON.stringify(this.duibiProduct))
            },
            delDuibi(row) {
                this.duibiProduct = this.duibiProduct.filter((item) => { return item !== row.product_id })
                sessionStorage.setItem("duibiProduct", JSON.stringify(this.duibiProduct))
            }
        }
    }
</script>
<style lang="scss" scoped>

    .duibi-wrap {
        position: sticky;
        height: 0;
        // 避让顶部固定 header；移动端 header 不固定，--site-nav-h 为 0
        top: var(--site-nav-h, 65px);
        z-index: 99;
        width: 100%;
    }

    .duibi-btn {
        transition: transform 0.42s cubic-bezier(0.45, 0.32, 0.37, 2);
        z-index: inherit;
        cursor: pointer;

        .duibi-badge {
            position: absolute;
            right: -2px;
            top: -2px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            background: #E34D59;
            border-radius: 50%;
            color: #ffffff;
            text-align: center;
        }

        @keyframes duibi-keyframes {
            0% {
                transform: translateY(0px);
            }

            50% {
                transform: translateY(4px);
            }

            100% {
                transform: translateY(0px);
            }
        }

        &:hover {
            transform: translateY(-6px);

            .duibi-badge {
                animation: duibi-keyframes 0.49s cubic-bezier(0.45, 0.32, 0.37, 2);
            }
        }
    }

    .product-wrap {
        width: 100%;
        margin-top: 20px;
        // position: relative;
        // overflow: hidden;
    }

    .duibi-add-btn,
    .duibi-del-btn {
        position: absolute;
        right: 10px;
        top: 15px;
        z-index: 1;
        width: 36px;
        text-align: center;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.26);
        transition: color .11s ease;

        &:hover {
            color: #0052D9;
        }
    }

    .product-tabs-wrap {
        background-color: #fff;
        width: 320px;
        z-index: 1;
        position: sticky;
        // 避让顶部固定 header，下留 10px 呼吸空间；移动端 header 不固定，--site-nav-h 为 0
        top: calc(var(--site-nav-h, 65px) + 10px);
        float: left;
        max-height: calc(100vh - var(--site-nav-h, 65px) - 20px);
        overflow-y: auto;
        padding: 10px;

        .product-tabs {
            display: flex;
            flex-direction: column;
            width: 100%;
            font-size: 16px;
            color: #333333;
            font-weight: bold;

            .product-tabs-item {
                height: 50px;
                line-height: 30px;
                cursor: pointer;
                width: 100%;
                padding: 10px;

                &:hover {
                    background-color: #fbfbfb;
                }
            }


            .product-tabs-item_active {
                color: #0052D9;

            }
        }
    }

    .product-content {
        margin-left: 340px;

        .xilie {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            position: sticky;
            padding: 10px 0;
            gap: 10px;
            // 紧贴固定 header 下沿吸顶，避免缝隙漏出滚动内容；移动端 header 不固定，--site-nav-h 为 0
            top: var(--site-nav-h, 65px);
            z-index: 2;
            background-color: #f5f5f5;
            margin-bottom: 10px;
        }

        .xiliemiaoshu-wrap {
            background-color: #ffffff;
            min-height: 180px;
            padding: 20px 30px;
            margin-bottom: 20px;
        }

        .xilietitle {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 20px;
            font-family: PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            white-space: nowrap;
            line-height: 30px;
            margin-bottom: 20px;
        }

        .xiliemiaoshu {
            overflow-wrap: break-word;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: normal;
            text-align: justify;
            line-height: 25px;
        }

        .chanpinlist {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(225px, 1fr));
            gap: 20px;
            width: 100%;
            overflow: hidden;
            // max-height: 700px;
            // overflow-y: auto;
            // overflow-x: hidden;

            .chanpin-item {
                background: #ffffff;
                cursor: pointer;
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                overflow: hidden;
                padding: 10px;

                &:hover {
                    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
                }

                &:hover .chanpinimage {
                    transform: scale(1.1);
                }
            }

            .chanpinimage {
                width: 225px;
                max-height: 225px;
                transition: transform 0.18s ease;
            }

            .chanpintitle {
                font-family: OPPOSans-H;
                margin-bottom: 10px;
            }

            .chanpinfubiao {
                text-align: center;
                width: 100%;
                color: rgba(51, 51, 51, 0.6);
                font-size: 12px;
                font-family: SourceHanSansCN-Regular;
                font-weight: 400;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .fangan-radio {
        margin-top: 5%;
        padding: 10px 0;
        width: 100%;
        background-color: #f5f5f5;
        z-index: 2;
        position: sticky;
        // 避让顶部固定 header；移动端 header 不固定，--site-nav-h 为 0
        top: var(--site-nav-h, 65px);
    }

    .fangan-list {
        margin: 10px 0;
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));


        .fangan-list-item {
            background: #fff;
            cursor: pointer;
            overflow: hidden;

            &:hover .jjimage {
                transform: scale(1.1);
            }

            &:hover .jjtitle {
                color: #0052D9;
            }
        }

        .jjimage-wrap {
            background-color: #ececec;
            width: 100%;
            height: 200px;
            overflow: hidden;

        }

        .jjimage {
            width: 100%;
            height: 100%;
            transition: transform 0.8s cubic-bezier(0.12, 0.13, 0, 1);
        }

        .jjtitle {
            color: #333333;
            font-weight: 550;
            text-align: center;
            padding: 10px;
        }
    }

    .anli {
        background-color: #fff;
        padding: 20px;

        .anli-item {
            cursor: pointer;
            margin-bottom: 30px;

            &:hover .yytitl {
                color: #0052D9;
            }
        }

        .yytitl {
            font-size: 20px;
            font-weight: 550;
            color: #333333;
            margin-bottom: 10px;
            transition: color 0.18s ease;
        }

        .yytitles {
            font-size: 16px;
            color: rgba(51, 51, 51, 0.5);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }


    // 手机端样式（与站点移动端断点、Element 的 xs 断点保持一致）
    @media screen and (max-width: 767px) {
        .duibi-wrap {
            top: 70%;
        }

        .product-tabs-wrap {
            width: 100%;
            margin-left: 0;
            // 移动端 header 不固定，侧边栏不再吸顶，直接跟随文档流
            position: static;
            max-height: none;
            overflow: visible;

            .product-tabs {
                flex-direction: row;
                flex-wrap: wrap;
                gap: 10px;

                .product-tabs-item {
                    line-height: 20px;
                    width: auto;
                    max-width: 100%;
                    height: auto;
                }
            }
        }

        .product-content {
            width: 100%;
            margin-left: 0;
            float: none;
        }

    }


    ::v-deep .el-tabs__item.is-active {
        color: #0052D9;
    }

    ::v-deep .el-tabs__item:hover {
        color: #0052D9;
    }

    ::v-deep .el-tabs__active-bar {
        padding-left: 3px;
        height: 0px !important;
        margin-top: 15px;
        background: #0052D9;
    }

    ::v-deep .el-tabs__nav-wrap::after {
        position: static !important;
        height: 0;
    }

    ::v-deep .el-tabs__item {
        font-weight: bold;
        height: 50px;
        line-height: 50px;
    }

    ::v-deep .el-pager li.active {
        color: #0052D9;
    }

    ::v-deep .el-pager li.active {
        color: #0052D9;
    }

    ::v-deep .el-pager li:hover {
        color: #0052D9;
    }


    ::v-deep .el-radio-button__inner {
        border: none;
        font-size: 15px;
    }

    ::v-deep .el-radio-button:last-child .el-radio-button__inner,
    ::v-deep .el-radio-button:first-child .el-radio-button__inner {
        border-radius: 0;
        border: none;
    }

    ::v-deep .el-radio-button__inner:hover {
        color: #0052D9;
    }

    ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: #0052D9;
        color: #FFF;
        box-shadow: none;
        border: none;
    }


</style>